import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import UPT from "../../../utilities/UPT";
import { useEffect, useState } from "react";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textcenter: {
        fontSize: 10,
        fontFamily: "Arial",
        textAlign:"center"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const CetakLHPLabnll = ({ dataDisposisi, datappm }) => {
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BALAI BESAR KARANTINA IKAN, PENGENDALIAN MUTU DAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>KEAMANAN PERIKANAN JAKARTA I</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JL. Soekarno Hatta South Perimeter, RT. 001/ RW.010, Panjang, Kec. Benda</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>Kota Tangerang, Banten 15126</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>LAPORAN HASIL PEMERIKSAAN LABORATORIUM</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>No. ........</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Berdasarkan surat perintah pemeriksaan laboratorium No. ………………. tanggal 17/03/2025 untuk pemilik sebagai berikut :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>a.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Perusahaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>CV. SIMPUL AGRO GLOBALINDO</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>b.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>JL. GUSUNG MAKMUR NO. 13 RT. 003 RW. 008, MACCINI SOMBALA, TAMALATE</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>c.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nomor Permohonan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>AL33.02025000001</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>d.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal Permohonan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>17 Maret 2025</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>e.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal Diagnosa</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>18 Maret 2025</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dengan hasil pemeriksaan produk hasil perikanan sebagai berikut :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableCer3}>
                    <View style={[styles.tableRow, { borderTop: 1 }]}>
                        <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={styles.textcenter}>No.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Nama Sampel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Jumlah Sampel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Pemeriksaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Jumlah Pengujian</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Hasil</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableCer3}>
                    <View style={[styles.tableRow, { borderTop: 1 }]}>
                        <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1 , borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textcenter}>1</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textcenter}>Kerapu Sunu</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textcenter}>1 ekor</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textcenter}>Uji Organoleptik di Lapangan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textcenter}>6</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                            <Text style={styles.textcenter}>Nilai 8</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Pemeriksa 	:</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '96%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ir. Sunarti Ahmad/ 197702202003122002/ Inspektur Mutu Ahli Muda</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kota, 14 Mei 2025</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala BBKIPM Jakarta I,</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '60%',marginVertical: 15 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%',marginVertical: 15 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Sri Anggoro</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table,  { width: '50%', paddingTop: 100 }]}>
                    <View style={styles.table}>
                        <View style={[styles.tableRow, { marginBottom: 10 }]}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Catatan :</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableCer3}>
                        <View style={[styles.tableRow, { borderTop: 1 }]}>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>1</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "90%", borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Hasil diagnosa ini hanya berlaku untuk contoh yang di diagnosa</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableCer3}>
                        <View style={[styles.tableRow, { borderTop: 1 }]}>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>2</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "90%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Laporan hasil diagnosa tidak boleh digandakan, kecuali secara lengkap seijin tertulis dari manajer puncak UPT ........</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default CetakLHPLabnll